module.exports = __webpack_public_path__ + "img/img6.1bc3d9cb.png";